import React, { useContext } from "react";

import { useTranslation } from "react-i18next";

import { DepositContext } from "@state/context/payment/DepositContext";
import { observer } from "mobx-react";

export default observer(function DepositLimitHeader() {
	const depositStore = useContext(DepositContext);

	const { t } = useTranslation("my-limits");

	return (
		<div className="popup__header">
			<div className="popup__title">{t(`DEPOSIT_LIMIT_POPUP_TITLE`)}</div>

			<button
				type="button"
				className="popup__close btn btn--icon btn--square btn--square--xsml btn--primary--inverted"
				onClick={() => {
					depositStore.depositLimitStore.deactivateDepositLimitPopup(
						false
					);
				}}
			>
				<i className="u-icon u-icon--tny u-icon--close" />
			</button>
		</div>
	);
});
